(function () {
  'use strict';

  // ============ Countdown — Target: 20. Aug 2026, 23:59:59 CEST (UTC+2) ============
  var TARGET = new Date('2026-08-20T23:59:59+02:00').getTime();

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    var diff = TARGET - now;

    if (diff <= 0) {
      var expiredMsg = 'Angebot abgelaufen — Regulärer Preis jetzt €769,00';
      var mini = document.getElementById('miniCountdown');
      if (mini) mini.innerHTML = expiredMsg;
      var big = document.getElementById('bigCountdown');
      if (big) big.innerHTML = '<div style="font-size:22px; color: var(--text-dim); padding: 24px;">' + expiredMsg + '</div>';
      var mob = document.getElementById('mobileCountdown');
      if (mob) mob.textContent = 'Angebot abgelaufen';
      return;
    }

    var days = Math.floor(diff / 86400000);
    var hours = Math.floor((diff / 3600000) % 24);
    var minutes = Math.floor((diff / 60000) % 60);
    var seconds = Math.floor((diff / 1000) % 60);

    var bar = document.getElementById('announceBar');
    if (bar) {
      if (days < 1) bar.classList.add('urgent');
      else bar.classList.remove('urgent');
    }

    var md = document.getElementById('md'); if (md) md.textContent = days;
    var mh = document.getElementById('mh'); if (mh) mh.textContent = pad(hours);
    var mm = document.getElementById('mm'); if (mm) mm.textContent = pad(minutes);

    var bd = document.getElementById('bd'); if (bd) bd.textContent = days;
    var bh = document.getElementById('bh'); if (bh) bh.textContent = pad(hours);
    var bm = document.getElementById('bm'); if (bm) bm.textContent = pad(minutes);
    var bs = document.getElementById('bs'); if (bs) bs.textContent = pad(seconds);

    var mobC = document.getElementById('mobileCountdown');
    if (mobC) mobC.textContent = 'Endet in ' + days + 'T ' + pad(hours) + 'h ' + pad(minutes) + 'm';
  }

  tick();
  setInterval(tick, 1000);

  // ============ Copy Discount Code ============
  function copyCode() {
    var code = 'IRON50';
    var btn = document.getElementById('copyBtn');
    var original = btn.textContent;

    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(fallback);
    } else {
      fallback();
    }

    btn.textContent = '✓ Code kopiert!';
    btn.classList.add('copied');
    setTimeout(function () {
      btn.textContent = original;
      btn.classList.remove('copied');
    }, 2000);
  }
  window.copyCode = copyCode;

  // ============ FAQ Accordion ============
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    q.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        var ai = i.querySelector('.faq-a');
        if (ai) ai.style.maxHeight = '0';
        var qi = i.querySelector('.faq-q');
        if (qi) qi.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ============ Video Tabs ============
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tab;
      document.querySelectorAll('.tab-btn').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      var content = document.querySelector('.tab-content[data-tab="' + target + '"]');
      if (content) content.classList.add('active');
    });
  });

  // ============ Lazy Video Loader (click-to-play) ============
  document.querySelectorAll('.video-wrap').forEach(function (wrap) {
    var poster = wrap.querySelector('.video-poster');
    if (!poster) return;
    poster.addEventListener('click', function () {
      var src = wrap.dataset.src;
      if (!src) return;
      var video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = 'auto';
      wrap.appendChild(video);
      poster.classList.add('hidden');
      setTimeout(function () { poster.remove(); }, 300);
    });
  });

  // ============ Scroll Reveal ============
  var revealEls = document.querySelectorAll('.stack-list li, .review, .card, .feature-card, .guarantee');
  revealEls.forEach(function (el, i) {
    el.classList.add('reveal');
    if (el.matches('.stack-list li')) {
      el.style.setProperty('--d', (i % 9) * 60 + 'ms');
    }
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
})();
